import gql from 'graphql-tag'
import { CloseButton } from 'shared-components/Components/CustomIcons/CloseButton/web'
import { useClickAway } from 'shared-components/GlobalHooks/useClickAway'
import { Carousel } from "src/Components/Carousel/web"
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { InfoWindowDesktop } from './InfoWindowDesktop/InfoWindowDesktop'
import './styles.less'
import { MapCard } from './MapCard/MapCard'
import { formatMoney } from '@Utils/Functions'

interface PaginatorInfo {
    firstItem: number;
    lastItem: number;
    lastPage: number;
    total: number;
    currentPage: number
}
interface InfoWindowProps {
    selectedMarker: string | null;
    isCluster: Boolean;
    closeCallback: () => void;
    currentIndex: any;
    nextPreviousCallback: (type, index) => void;
    carouselData: Array<any>;
    loadMoreData: () => void;
    onVisibleIdChange: (lat, lng, id) => void;
    paginatorInfo: PaginatorInfo;
}

function isBase64(str) {
    if (!str || str.length % 4 !== 0) {
        return false;
    }

    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;

    return base64Regex.test(str);
}

export const InfoWindow: React.FC<InfoWindowProps> = ({ selectedMarker, isCluster, closeCallback, currentIndex, nextPreviousCallback, carouselData, loadMoreData, onVisibleIdChange, paginatorInfo }) => {
    if (!selectedMarker || paginatorInfo.total === 0) return null;

    const screen = useWindowSize();
    const clickAwayRef = useClickAway(closeCallback);
    let currentPropID = selectedMarker;
    let dataJson = [];

    if (isCluster && isBase64(currentPropID)) {
        dataJson = JSON.parse(atob(currentPropID));

        if (!dataJson.length || !dataJson[currentIndex]?.propID) {
            return null;
        };

        currentPropID = dataJson[currentIndex].propID;
    };

    return (
        <>
            {
                screen.xl ?
                    <InfoWindowDesktop
                        currentIndex={currentIndex}
                        carouselData={carouselData}
                        closeCallback={closeCallback}
                        nextPreviousCallback={nextPreviousCallback}
                        onEndReached={loadMoreData}
                        paginatorInfo={paginatorInfo}
                    />
                :
                    <div className="overlay-wrapper">
                        <div className="overlay-wrapper__top">
                            {!screen.xl ? (
                                <div className='carousel-paginator'>
                                    <span>{currentIndex + 1} / {formatMoney(paginatorInfo.total)}</span>
                                </div>
                                ) :null
                            }

                            <button onClick={closeCallback} className="close-button"><CloseButton /></button>
                        </div>

                        <div className="overlay-wrapper__container">
                            <Carousel data={carouselData} ItemComponent={PropertyCarouselItem} onEndReached={loadMoreData} onVisibleIdChange={onVisibleIdChange} />
                        </div>
                    </div>
            }
        </>
    );
};

const PropertyCarouselItem = ({ data }) => <MapCard data={data} isActive={false} />
